'use client'

import PropTypes from 'prop-types'
import { WizardIconTitle } from '@repo/ui/WizardIconTitle'
import { WizardFormSection } from '@repo/ui/WizardFormSection'
import { WizardPanel } from '@repo/ui/WizardPanel'
import { WizardFooter } from '@repo/ui/WizardFooter'
import { LargeFeeEarnerIcon } from '@repo/ui/LargeFeeEarnerIcon'
import { FeeEarnerSelect } from '@repo/ui/FeeEarnerSelect'
import { useNewMatterStore } from '@repo/store/useNewMatterStore'
import { useState } from 'react'

export const NewMatterFeeEarner = ({ updateStepState, wideMode, handlePrevNext }) => {
  const { feeEarner, supervisingFeeEarner, updateState } = useNewMatterStore()
  const [validationErrors, setValidationErrors] = useState({})

  const handleClickContinue = () => {
    if (!feeEarner) {
      setValidationErrors({ feeEarner: 'Fee earner is required' })
      return
    }

    const feeEarnerList = [feeEarner.description, supervisingFeeEarner?.description || null].filter(Boolean)
    updateStepState({ status: 'completed', statusText: feeEarnerList.join(', ') })
    handlePrevNext(1)
  }

  const handleClickBack = () => {
    handlePrevNext(-1)
  }

  return (
    <>
      <WizardPanel data-testid="NewMatterFeeEarner">
        <WizardFormSection>
          <WizardIconTitle title={'Fee earner'} icon={LargeFeeEarnerIcon} sx={{ mb: 8, width: '100%' }} />

          <FeeEarnerSelect
            value={feeEarner}
            onChange={(value) => updateState({ key: 'feeEarner', value })}
            sx={{ width: '100%', maxWidth: '486px' }}
            size="medium"
            required
            name="feeEarner"
            errors={validationErrors}
          />

          <FeeEarnerSelect
            value={supervisingFeeEarner}
            onChange={(value) => updateState({ key: 'supervisingFeeEarner', value })}
            sx={{ width: '100%', maxWidth: '486px' }}
            size="medium"
            label="Supervising fee earner"
            name="supervisingFeeEarner"
            onlyIncludeSupervisingFeeEarners
            errors={validationErrors}
          />
        </WizardFormSection>
      </WizardPanel>
      <WizardFooter wideMode={wideMode} handleClickContinue={handleClickContinue} handleClickBack={handleClickBack} />
    </>
  )
}

NewMatterFeeEarner.propTypes = {
  updateStepState: PropTypes.func,
  currentStep: PropTypes.object,
  wideMode: PropTypes.bool,
  handlePrevNext: PropTypes.func
}
